class QuickAdd extends window.BAO.CustomElement() {
  setupListeners () {
    this.cache = new Map()
    this.requestId = 0
    this.abortController = null

    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onClick = this.onClick.bind(this)
    this.onPointerDown = this.onPointerDown.bind(this)
    this.onPointerMove = this.onPointerMove.bind(this)
    this.onPointerUp = this.onPointerUp.bind(this)
    this.onDragClick = this.onDragClick.bind(this)

    this.trackingCarousel = false
    this.carouselDrag = false

    this.listeners.add(document, 'click', this.onDocumentClick)
    this.listeners.add(this, 'click', this.onClick)
    this.listeners.add(document, 'pointerdown', this.onPointerDown)

    document.addEventListener('click', this.onDragClick, true)
  }

  disconnectedCallback () {
    this.stopCarouselTracking()
    document.removeEventListener('click', this.onDragClick, true)
    super.disconnectedCallback()
  }

  onPointerDown (event) {
    const carousel = event.target.closest('#QuickAddDrawer product-card-carousel')

    this.stopCarouselTracking()
    this.carouselDrag = false
    this.trackingCarousel = Boolean(carousel)

    if (!this.trackingCarousel) return

    this.pointerStartX = event.clientX
    this.pointerStartY = event.clientY

    document.addEventListener('pointermove', this.onPointerMove)
    document.addEventListener('pointerup', this.onPointerUp)
    document.addEventListener('pointercancel', this.onPointerUp)
  }

  onPointerMove (event) {
    if (!this.trackingCarousel || this.carouselDrag) return

    const dx = event.clientX - this.pointerStartX
    const dy = event.clientY - this.pointerStartY

    if ((dx * dx) + (dy * dy) > 16) this.carouselDrag = true
  }

  onPointerUp () {
    this.stopCarouselTracking()

    window.setTimeout(() => {
      this.carouselDrag = false
    }, 0)
  }

  onDragClick (event) {
    if (!this.carouselDrag) return

    this.carouselDrag = false
    event.stopPropagation()
  }

  stopCarouselTracking () {
    document.removeEventListener('pointermove', this.onPointerMove)
    document.removeEventListener('pointerup', this.onPointerUp)
    document.removeEventListener('pointercancel', this.onPointerUp)
  }

  onDocumentClick (event) {
    const trigger = event.target.closest('[data-quick-add-trigger]')

    if (!trigger) return

    event.preventDefault()

    const handle = trigger.getAttribute('data-product-handle')

    this.open(handle)
  }

  onClick (event) {
    const swatch = event.target.closest('a.prd-ProductSwatches_Swatch')

    if (!swatch || !this.contains(swatch)) return

    const handle = this.handleFromUrl(swatch.href)

    if (!handle) return

    event.preventDefault()
    this.open(handle)
  }

  async open (handle) {
    if (!handle) return

    const requestId = ++this.requestId
    const dialog = this.closest('dialog')
    const isOpen = window.drawers?.activeDrawerKey === 'quick-add'

    if (
      this.dataset.productHandle === handle &&
      this.els.content.element.querySelector('[data-quick-add-product]')
    ) {
      window.drawers?.open('quick-add')
      return
    }

    dialog?.setAttribute('aria-busy', 'true')

    if (isOpen) this.showStatus(this.dataset.loadingMessage)

    this.abortController?.abort()
    this.abortController = new AbortController()

    try {
      const markup = await this.fetchProduct(handle, this.abortController.signal)

      if (requestId !== this.requestId) return

      this.render(markup, handle)
      window.drawers?.open('quick-add')
    } catch (error) {
      if (error?.name === 'AbortError' || requestId !== this.requestId) return

      this.dataset.productHandle = ''
      this.showStatus(this.dataset.errorMessage)
      window.drawers?.open('quick-add')
    } finally {
      if (requestId === this.requestId) {
        dialog?.removeAttribute('aria-busy')
      }
    }
  }

  async fetchProduct (handle, signal) {
    if (this.cache.has(handle)) return this.cache.get(handle)

    const response = await window.fetch(this.productUrl(handle), { signal })

    if (!response.ok) throw new Error('Quick add request failed')

    const markup = await response.text()
    const template = document.createElement('template')

    template.innerHTML = markup

    if (!template.content.querySelector('[data-quick-add-product]')) {
      throw new Error('Quick add markup missing')
    }

    this.cache.set(handle, markup)

    return markup
  }

  render (markup, handle) {
    const template = document.createElement('template')

    template.innerHTML = markup

    const product = template.content.querySelector('[data-quick-add-product]')
    const modal = template.content.querySelector('[data-quick-add-size-guide]')

    document.querySelector('[data-quick-add-size-guide]')?.remove()

    this.els.content.element.replaceChildren(product)
    this.dataset.productHandle = handle
    this.els.content.element.querySelector('product-card-carousel')?.hydrateSlides()

    if (modal) {
      document.body.append(modal)
      this.closest('dialog')?.append(modal)
    }

    this.refreshWidgets()
  }

  showStatus (message) {
    const status = document.createElement('p')

    status.className = 'qad-QuickAdd_Status fz-12_140'
    status.textContent = message || ''

    this.els.content.element.replaceChildren(status)
  }

  refreshWidgets () {
    window.yotpoWidgetsContainer?.initWidgets?.()
    window.yotpo?.initWidgets?.()

    window.KlarnaOnsiteService = window.KlarnaOnsiteService || []
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' })
  }

  productUrl (handle) {
    const root = window.routes?.root_url || '/'
    const base = root.endsWith('/') ? root : `${root}/`

    return `${base}products/${encodeURIComponent(handle)}?view=quick-add`
  }

  handleFromUrl (url) {
    const path = new URL(url, window.location.origin).pathname
    const parts = path.split('/').filter(Boolean)
    const productIndex = parts.indexOf('products')
    const handle = productIndex >= 0 ? parts[productIndex + 1] : ''

    return handle ? decodeURIComponent(handle) : ''
  }
}

if (!customElements.get('quick-add')) {
  customElements.define('quick-add', QuickAdd)
}
